/**
 * Telegram Analytics Configuration
 * 
 * To set up Telegram Analytics:
 * 1. Contact @DataChief_bot on Telegram to get your token and app name
 * 2. Set the environment variables VITE_TELEGRAM_ANALYTICS_TOKEN and VITE_TELEGRAM_ANALYTICS_APP_NAME
 * 3. The SDK will be automatically initialized when the app starts
 */

import { debugLog } from '../utils/logger';

export interface TelegramAnalyticsConfig {
  token: string;
  appName: string;
}

export const getTelegramAnalyticsConfig = (): TelegramAnalyticsConfig | null => {
  const token = import.meta.env.VITE_TELEGRAM_ANALYTICS_TOKEN;
  const appName = import.meta.env.VITE_TELEGRAM_ANALYTICS_APP_NAME;

  if (!token || !appName) {
    debugLog(
      'Telegram Analytics not configured. Please set VITE_TELEGRAM_ANALYTICS_TOKEN and VITE_TELEGRAM_ANALYTICS_APP_NAME environment variables. ' +
      'Get your credentials from @DataChief_bot on Telegram.'
    );
    return null;
  }

  return {
    token,
    appName,
  };
};

export const isTelegramAnalyticsEnabled = (): boolean => {
  return getTelegramAnalyticsConfig() !== null;
}; 